




















import { LearningOutcomeItem } from '../types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InfoBlock extends Vue {
  // props
  @Prop({
    required: true,
  })
  item: LearningOutcomeItem;

  @Prop({
    default: 4,
  })
  previewCount: number;

  // data
  private previewCountData: number = this.previewCount;

  // computed
  get currentPreviewCount() {
    return this.previewCountData;
  }

  set currentPreviewCount(val) {
    this.previewCountData = val;
  }

  get programName() {
    return {
      label: 'Программа: ',
      value: this.item.event_name,
      to: {
        name: 'event-card',
        params: {
          // TODO: как появятся url_code и program_id (названия могут измениться) - доработать router-link
          code: 'programma-8-vecher-mir',
          id: '8',
        },
      },
    };
  }

  get documentUrl() {
    return {
      docUrl: 'https://ya.ru/',
    };
  }

  async getDoc(id: string) {
    const data = await this.$axiosInstance.post(
      'profile/document/download/' + id,
      {},
      {
        responseType: 'blob',
      }
    );
    const href = URL.createObjectURL(data.data);
    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    document.body.appendChild(link);
    link.click();
    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  get infoElements() {
    return [
      {
        label: 'Период обучения: ',
        value:
          this.item.date_from && this.item.date_to
            ? `${
                this.item.date_from
                  ? this.$util.dateConvertApiFormatToRusViewFormat(
                      this.item.date_from
                    )
                  : '-'
              }  - ${
                this.item.date_to
                  ? this.$util.dateConvertApiFormatToRusViewFormat(
                      this.item.date_to
                    )
                  : '-'
              }`
            : '-',
      },
      {
        label: 'Итоговая оценка: ',
        value: this.item.mark_final ? this.item.mark_final : '-',
      },
      {
        label: 'Обучающая организация: ',
        value: this.item.event_edu_partners
          ? this.item.event_edu_partners
          : '-',
      },
      {
        label: 'Компетенции: ',
        value: this.item.competences ? this.item.competences : '-',
      },
      {
        label: 'Профессии: ',
        value: this.item.profession_name ? this.item.profession_name : '-',
      },
      {
        label: 'Направление ОПП: ',
        value: this.item.direction_prog_name
          ? this.item.direction_prog_name
          : '-',
      },
      {
        label: 'Название группы: ',
        value: this.item.group_name ? this.item.group_name : '-',
      },
      {
        label: 'Вид программы: ',
        value: this.item.type ? this.item.type : '-',
      },
      {
        label: 'Подвид программы: ',
        value: this.item.sub_type ? this.item.sub_type : '-',
      },
    ];
  }

  // methods
  public expand() {
    this.currentPreviewCount === this.infoElements.length
      ? (this.currentPreviewCount = this.previewCount)
      : (this.currentPreviewCount = this.infoElements.length);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/resultCourses/components/InfoBlock.vue